import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getJob } from './jobApi';


const initialState = {
    job: {},
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk


export const fetchJob = createAsyncThunk("job/fetchJob", async (id) => {
    const job = await getJob(id);
    return job;
});

export const jobSlice = createSlice({
    name: 'job',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(fetchJob.pending, (state) => {
            state.isError = false;
            state.isLoading = true;
        })
            .addCase(fetchJob.fulfilled, (state, action) => {
                state.isLoading = false;
                state.job = action.payload;
            })
            .addCase(fetchJob.rejected, (state, action) => {
                state.isLoading = false;
                state.job = {};
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export const { } = jobSlice.actions;
export default jobSlice.reducer;
